export default "__VITE_ASSET__c354a736__"